import { createFileRoute } from '@tanstack/react-router'
import { EgressRoom } from '../features/pitch/components/egress-room'

export const Route = createFileRoute('/livekit-egress-template')({
  component: LiveKitEgressTemplatePage,
})

/**
 * Route for LiveKit egress recording template.
 * This page is loaded by the LiveKit egress service to record room composites.
 *
 * URL parameters are provided by LiveKit egress:
 * - url: LiveKit server URL
 * - token: Access token for the room
 * - layout: Optional layout identifier
 *
 * @see https://docs.livekit.io/transport/media/ingress-egress/egress/custom-template/
 */
function LiveKitEgressTemplatePage() {
  return <EgressRoom />
}
